import { render, staticRenderFns } from "./Forbidden.vue?vue&type=template&id=3d1cbeaf&scoped=true"
import script from "./Forbidden.vue?vue&type=script&lang=ts"
export * from "./Forbidden.vue?vue&type=script&lang=ts"
import style0 from "./Forbidden.vue?vue&type=style&index=0&id=3d1cbeaf&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d1cbeaf",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3d1cbeaf')) {
      api.createRecord('3d1cbeaf', component.options)
    } else {
      api.reload('3d1cbeaf', component.options)
    }
    module.hot.accept("./Forbidden.vue?vue&type=template&id=3d1cbeaf&scoped=true", function () {
      api.rerender('3d1cbeaf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Forbidden.vue"
export default component.exports